export const PROVIDER_CONFIG = {
  name: "Ivory Haven",
  address: {
    street: "123 Dental Plaza",
    city: "Healthcare City",
    state: "HC",
    zip: "12345",
  },
  phone: "(555) 123-4567",
};
